import React from "react";
import Anav from "../components/Anav";
import Btable from "../components/Btable";
import Homefooter from "../components/Homefooter";

function Bookings() {
    return (
        <>
            <Anav />
            <Btable />
            <Homefooter />
        </>
    );
}

export default Bookings;